// extracted by mini-css-extract-plugin
export default {"addToCartControl":"j2-z","giftCard":"k2-z","btnContainer":"l2-z","cartButton":"m2-z","disabled":"n2-z"};